import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromCategoriesActions from './store-categories.actions';
import * as fromReducer from '../store.reducer';
import {
  CategoryModel,
  IStoreCategoriesStateError,
  IStoreCategoriesStateSuccess,
  IUpsertCategoryPayload,
} from '@boxx/store-core';
import * as fromSelectors from './store-categories.selectors';
import { IStoreBase } from '@boxx/core';

@Injectable()
export class StoreCategoriesStore
  implements
    IStoreBase<
      CategoryModel[],
      IStoreCategoriesStateSuccess,
      IStoreCategoriesStateError
    >
{
  constructor(public store: Store<fromReducer.IStoreState>) {}

  get loading$() {
    return this.store.select(fromSelectors.getCategoriesIsloading);
  }
  get data$() {
    return this.store.select(fromSelectors.getCategoriesData);
  }
  get fetched$() {
    return this.store.select(fromSelectors.getCategoriesHasBeenFetched);
  }
  get error$() {
    return this.store.select(fromSelectors.getCategoriesError);
  }
  get success$() {
    return this.store.select(fromSelectors.getCategoriesSuccess);
  }

  fetch = () =>
    this.store.dispatch(fromCategoriesActions.loadCategoriesBeginAction());

  fetchById = (id: number) =>
    this.store.dispatch(
      fromCategoriesActions.loadCategorieByIdBeginAction({ id })
    );

  create = (payload: IUpsertCategoryPayload) =>
    this.store.dispatch(
      fromCategoriesActions.createCategoryBeginAction({ payload })
    );

    update = (payload: IUpsertCategoryPayload) =>
    this.store.dispatch(
      fromCategoriesActions.updateCategoryBeginAction({ payload })
    );

  delete = (id: number) =>
    this.store.dispatch(
      fromCategoriesActions.deleteCategoryBeginAction({ id })
    );

  uploadCategoryImage = (id: number, file: string) =>
    this.store.dispatch(
      fromCategoriesActions.uploadImageCategoryBeginAction( {id, file} )
    );

    deleteImage = (id: number) =>
    this.store.dispatch(
      fromCategoriesActions.deleteImageCategoryBeginAction({ id })
    );

    getSingleCategory = (id: number) =>
    this.store.dispatch(
      fromCategoriesActions.loadImageCategoryUploadedBeginAction( {id} )
    );

    refreshCategories = (payload: CategoryModel[]) =>
    this.store.dispatch(
      fromCategoriesActions.loadCategoriesSuccessAction({ payload })
    );

}
